<template>
  <div class="content-container">
    <search-comp
      @onSearch="getListUser"
      @onReset="
        () => {
          searchParams.search_information = ''
          getListUser()
        }
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Người dùng</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.search_information"
                    type="text"
                    placeholder="Nhập họ và tên hoặc tên đăng nhập"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-row">
          <div class="das-form-col col-6">
            <div class="grid-wrapper gridScroll agGrid" style="height: 100%">
              <GridVx
                ref="agGrid"
                :columns="userColumns"
                :auto-select-first-row="true"
                :rows="userRows"
                dom-layout="scroll"
                class="agGrid"
                :auto-size-cell="true"
                row-selection="single"
                @selectionChanged="onSelectUser"
              />
            </div>
          </div>
          <div v-loading="functionGridLoading" class="das-form-col col-6">
            <GridVx
              ref="agGridFunction"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :auto-select-first-row="false"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="button-containers mb-0">
      <button class="btn primary small" @click="saveAssign">
        {{ $t('button.save') }}
      </button>
    </div>

    <el-dialog
      :title="!isEdit ? 'Thêm bộ phận' : 'Sửa bộ phận'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã bộ phận</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã bộ phận"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        :disabled="isEdit"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Tên bộ phận</div>
                  <validation-provider
                    rules="required|max:50"
                    name="Tên bộ phận"
                  >
                    <input v-model="form.name" type="text" />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Mô tả</div>
                  <validation-provider rules="max:255" name="Mô tả bộ phận">
                    <textarea
                      v-model="form.description"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col">
                <div class="das-form-input">
                  <div class="label" />

                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="form.record_empl"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3"
                      >Ghi nhận doanh thu cho nhân viên</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateDepartment"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small outline"
            @click="addDepartment"
          >
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import {
  getUserApi,
  getFunctionAssignApi,
  setFunctionAssignApi
} from '@/api/userConfig/user'
import IconSvg from '@/components/IconSvg/index.vue'
import { CellRenderIconQuestion } from '@/utils/cellRenders'

import { CellRenderCheckboxReadonly } from '@/utils/cellRenders.js'
import {
  getDepartmentApi,
  addDepartmentApi,
  deleteDepartmentApi,
  updateDepartmentApi
} from '@/api/userConfig/department'
export default {
  components: {
    CellRenderCheckboxReadonly,
    IconSvg,
    CellRenderIconQuestion
  },
  data() {
    return {
      functionGridLoading: false,
      accountId: '',
      defaultForm: {
        id: null,
        code: '',
        name: '',
        description: '',
        record_empl: false
      },
      form: {
        id: null,
        code: '',
        name: '',
        description: '',
        record_empl: false
      },
      titlePopup: 'Thêm bộ phận',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        search_information: '',
        is_active: true
      },
      userColumns: [
        {
          headerName: this.$t('grid.column.employeeID'),
          field: 'code',
          minWidth: 80,
          maxWidth: 140
        },
        {
          headerName: this.$t('grid.column.fullname'),
          field: 'full_name',
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.username'),
          field: 'username',
          minWidth: 100
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      userRows: [],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.function'),
          field: 'desc',
          tooltipField: 'desc',
          minWidth: 120
        },
        {
          headerName: this.$t('grid.column.functionCode'),
          field: 'code',
          tooltipField: 'code',
          minWidth: 150
        },
        {
          headerName: '',
          field: 'note',
          cellRenderer: 'CellRenderIconQuestion',
          minWidth: 40,
          maxWidth: 40,
          tooltipField: 'note'
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetBuildingInfo()
    },
    rows: {
      handler(val) {
        this.$nextTick(() => {
          const gridApi = this.$refs.agGridFunction.gridApi
          gridApi.forEachNode(node => {
            if (node.data?.inUse) {
              node.setSelected(true)
            }
          })
          this.functionGridLoading = false
        })
      }
    }
  },

  async mounted() {
    await this.getListUser()
    this.accountId = this.userRows[0].id
    // this.getFunctionAssign()
  },
  methods: {
    onSelectUser(val) {
      this.accountId = val[0].id
      this.getFunctionAssign()
    },
    async getListUser() {
      let data = await getUserApi(this.searchParams)
      this.userRows = data?.data.map(item => item.account)
    },
    async getFunctionAssign() {
      this.functionGridLoading = true
      const params = {
        accountId: this.accountId
      }
      let data = await getFunctionAssignApi(params)
      this.rows = data?.data
      this.functionGridLoading = false
    },
    saveAssign() {
      const gridApi = this.$refs.agGridFunction.gridApi
      const selectedRows = gridApi.getSelectedRows()
      let selectFunctionId = selectedRows.map(element => element.id)
      setFunctionAssignApi(this.accountId, selectFunctionId)
        .then(data => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.getFunctionAssign()
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
    },
    async attachData() {
      let data = await getDepartmentApi(this.searchParams)
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : this.searchParams.pageNum
    },
    async addDepartment() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      this.form.name = this.form.name.trim()
      await addDepartmentApi(this.form)
        .then(data => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.attachData()
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
    },
    async updateDepartment() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      this.form.name = this.form.name.trim()

      await updateDepartmentApi(this.form)
        .then(data => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.attachData()
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
      // this.dialogFormVisible = false
      // this.$message({
      //   type: 'success',
      //   message: 'Bạn đã cập nhật bộ phận thành công'
      // })
      // this.attachData()
    },

    deleteDepartment() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$vxAlert('Bạn chưa chọn bộ phận!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá bộ phận này?', async () => {
          await deleteDepartmentApi({ id_list: id_list })
            .then(data => {
              this.$message({
                type: 'success',
                message: this.$t('successMsg.' + data.message)
              })
              this.attachData()
            })
            .catch(err => {
              this.$message({
                type: 'error',
                message: this.$t('errorMsg.' + err.response.data.message)
              })
              this.dialogFormVisible = false
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },

    updateDepartmentView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 bộ phận để sửa')
      } else {
        this.titlePopup = 'Sửa bộ phận'
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form = { ...rowData }
        this.dialogFormVisible = true
      }
    },
    resetBuildingInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
